import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { FormControlName, NgModel } from '@angular/forms';
import { AxisInputNumberPipe } from './axis.input.number.pipe';

export interface InputSettings {
  prefix?: string;
  decimal_separator?: string;
  thousands_separator?: string;
  suffix?: string;
  fraction_size?: number;
  max?: number;
  min?: number;
  decimal?: number;
  restrict?: boolean;
  reg_exp?: any;
  max_length?: number;
  view_roundoff?: boolean;
}
@Directive({
  selector:
    '[axisInputNumber], [axisInputNumber][ngModel], [axisInputNumber][formControlName], [axisInputNumber][formControl]'
})
export class AxisInputNumberDirective implements OnInit, AfterViewInit {
  private inputEl: any;
  @ViewChild('axisInputNumber', { static: true }) input: ElementRef;
  @Input('axisInputNumber') settings: InputSettings;
  @Output() onMaxLengthExceeds = new EventEmitter();
  private el: any;
  private previousValue: any = '';
  private isFocus = false;
  private value: any;
  private isOnLoad = true;
  private isPasted = false;
  protected defaultSettings: any = {
    prefix: '',
    decimal_separator: '.',
    thousands_separator: '',
    suffix: '',
    fraction_size: null,
    max: '',
    min: '',
    decimal: '',
    restrict: false,
    reg_exp: '',
    max_length: '',
    view_roundoff: false
  };

  constructor(
    private elementRef: ElementRef,
    private currencyPipe: AxisInputNumberPipe,
    private model: NgModel,
    private formControlName: FormControlName,
    private cd: ChangeDetectorRef
  ) {
    this.el = this.elementRef.nativeElement;
    this.input = this.elementRef.nativeElement;
  }

  ngOnInit() {
    if (this.settings) {
      this.settings.decimal_separator = this.settings.decimal_separator
        ? this.settings.decimal_separator
        : this.defaultSettings.decimal_separator;
      this.settings.fraction_size =
        this.settings.fraction_size || this.settings.fraction_size === 0
          ? this.settings.fraction_size
          : this.defaultSettings.fraction_size;
      this.settings.max =
        this.settings.max || this.settings.fraction_size === 0
          ? this.settings.max
          : this.defaultSettings.max;
      this.settings.min =
        this.settings.min || this.settings.fraction_size === 0
          ? this.settings.min
          : this.defaultSettings.min;
      this.settings.prefix =
        this.settings.prefix || this.defaultSettings.prefix;
      this.settings.suffix =
        this.settings.suffix || this.defaultSettings.suffix;
      this.settings.thousands_separator =
        this.settings.thousands_separator ||
        this.defaultSettings.thousands_separator;
      this.settings.reg_exp =
        this.settings.reg_exp || this.defaultSettings.reg_exp;
      this.settings.decimal =
        this.settings.decimal || this.defaultSettings.decimal;
      this.settings.restrict =
        this.settings.restrict || this.defaultSettings.restrict;
      this.settings.max_length =
        this.settings.max_length || this.defaultSettings.max_length;
      this.settings.view_roundoff =
        this.settings.view_roundoff || this.defaultSettings.view_roundoff;
    } else {
      this.settings = this.defaultSettings;
    }
    if (this.model && this.model.model) { // in case of ngModel value was not updated
      this.el.value = this.model.model;
    }
    if (this.settings.view_roundoff) {
      this.value = this.currencyPipe.parse(this.el.value, this.settings);
    } else {
      this.value = this.currencyPipe.parse(this.currencyPipe.transform(this.el.value, this.settings), this.settings);
    }
    this.el.value = this.currencyPipe.transform(this.el.value, this.settings);
    this.previousValue = this.currencyPipe.parse(this.el.value, this.settings);
    if (this.formControlName && this.formControlName.valueChanges) {
      this.updateModel();
      this.el.value = this.currencyPipe.transform(this.el.value, this.settings);
      this.formControlName.valueChanges
        .subscribe(value => {
          this.value = value;
          if (value) {
            value = value.toString().replace(this.settings.decimal_separator, '.');
          }
          this.modelUpdate(value, 'form');
        });
    } else if (
      this.model &&
      this.model.valueChanges &&
      this.model.hasOwnProperty('viewModel')
    ) {
      this.model.valueChanges.subscribe(value => {
        if (this.settings.view_roundoff) {
          this.value = value;
        } else {
          this.value = this.currencyPipe.parse(this.currencyPipe.transform(this.el.value, this.settings), this.settings);
        }
        if (this.isOnLoad) {
          this.updateModel();
        }
        if (value) {
          value = value.toString().replace(this.settings.decimal_separator, '.');
        }
        this.modelUpdate(value, 'model');
        this.isOnLoad = false;
      });
    }
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  updateModel() {
    if (this.settings.decimal_separator) {
      this.value = this.value && this.value.toString().replace(this.settings.decimal_separator, '.');
    }
    if (!this.settings.view_roundoff) {
      if (this.model.hasOwnProperty('viewModel')) {
        setTimeout(() => {
          this.model.update.emit(this.value);
        }, 0);
      } else if (this.formControlName && this.formControlName.valueChanges) {
        this.formControlName.control.setValue(this.value);
      }
    }
  }

  updateModelValue(type) {
    if (type === 'form') {
      if (this.formControlName.control.value !== this.previousValue) {
        this.formControlName.control.setValue(this.previousValue);
      }
    } else {
      this.el.value = this.previousValue;
      if (this.model.value !== this.previousValue) {
        this.model.update.emit(this.previousValue);
      }
    }
  }


  modelUpdate(value, type, event = undefined) {
    let patternToMatch;
    const regExp: RegExp = /^((-?\d*\.?\d*([kKmMtTbB])?$)+(([-])?([0-9]{1,3})?)+(,[0-9]{3})*(\.[0-9]{0,})?)([kKmMtTbB])?$/g;
    if (value || value === 0) {
      value = value.toString();
    }
    if (this.settings.reg_exp) {
      patternToMatch = new RegExp(this.settings.reg_exp, 'g');
    } else {
      patternToMatch =
        this.settings.suffix === '%' ? /^-?\d*\.{0,1}?\d*$/ : regExp;
    }
    if (value === null || value === undefined || value.toString().trim().length === 0) {
      this.previousValue = '';
      this.updateModelValue(type);
      return;
    }
    if (!patternToMatch.test(value)) {
      this.el.value = this.previousValue;
      this.previousValue = this.el.value;
      if (type === 'model') {
        this.model.update.emit(this.el.value);
      } else if (type === 'form') {
        this.formControlName.control.setValue(this.el.value);
      }
    } else {
      if (this.settings.max_length && value) {
        if (!value.match(regExp)) {
          if (value.length > this.settings.max_length) {
            value = value.slice(0, this.settings.max_length);
            this.el.value = value;
            if (event && event['inputType'] === 'insertFromPaste') {
              this.onMaxLengthExceeds.emit();
              this.isPasted = true;
            }
          }
        } else {
          if (this.settings.thousands_separator !== '.') {
            value = value
              .toString()
              .split(this.settings.thousands_separator)
              .join('');
          }

          if (value.length > this.settings.max_length) {
            value = value.slice(0, this.settings.max_length);
            this.el.value = value;
            if (event && event['inputType'] === 'insertFromPaste') {
              this.onMaxLengthExceeds.emit();
              this.isPasted = true;
            }
          }
        }
      }
      if (this.settings.suffix === '%') {
        if (this.settings.restrict) {
          if (this.settings.max && value > this.settings.max) {
            value = this.previousValue;
            this.el.value = value;
            this.model.update.emit(value);
          } else if (!this.settings.max) {
            const max = 100;
            if (value > max) {
              this.el.value = max;
              value = max;
            }
          }
        } else {
          if (this.settings.max && value > this.settings.max) {
            this.el.value = this.settings.max;
            value = this.settings.max;
            this.model.update.emit(value);
          }
        }
      } else if (
        this.settings.max &&
        value > this.settings.max &&
        !this.settings.restrict
      ) {
        this.el.value = this.settings.max;
        value = this.settings.max;
      } else if (
        this.settings.max &&
        value > this.settings.max &&
        this.settings.restrict
      ) {
        value = this.previousValue;
        this.el.value = value;
        this.model.update.emit(value);
      }
      this.previousValue = value;
      this.updateModelValue(type);
      if (!this.isFocus) {
        this.el.value = this.currencyPipe.transform(value, this.settings);
      }
    }
  }

  @HostListener('input', ['$event', '$event.target.value'])
  onInputChange(event, value) {
    if (
      !this.formControlName.valueChanges
    ) {
      value = value.replace(this.settings.decimal_separator, '.');
      this.modelUpdate(value, 'default', event);
    }
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    this.isFocus = true;
    if (!this.settings.view_roundoff) {
      value = value.split(this.settings.thousands_separator).join('');
      value = value.replace(this.settings.decimal_separator, '.');
    }
    let inputVal = this.settings.view_roundoff ? this.value : value;

    this.el.value =
      inputVal && (inputVal !== this.settings.suffix || this.settings.prefix)
        ? this.currencyPipe.parse(inputVal, this.settings)
        : ''; // opossite of transform
    this.el.value = this.el.value.replace(this.settings.decimal_separator, '.');
    if (
      !this.formControlName.valueChanges &&
      !this.model.hasOwnProperty('viewModel') &&
      !inputVal
    ) {
      inputVal = inputVal.replace(this.settings.decimal_separator, '.');
      this.modelUpdate(inputVal, 'default');
    }
  }

  @HostListener('blur', ['$event', '$event.target.value'])
  onBlur(event, value) {
    this.isFocus = false;
    if (value.slice(-1) === this.settings.decimal_separator || value.slice(-1) === '.') {
      value = value.replace(this.settings.decimal_separator || '.', '');
    }
    if (this.isPasted) {
      value = value
        .toString()
        .split(this.settings.thousands_separator)
        .join('');
    }
    event.target.value = value;
    if (this.settings.suffix !== '%' && event.target.value.length > 1) {
      const patternDefaultMatch = /^(([+-])?[0-9]*(\.[0-9]{0,})?)([kKmMtTbB])?$/g;
      if (!(value && !patternDefaultMatch.test(value))) {
        // if user input 'K/k' keyword
        if (
          event.target.value.slice(-1) === 'k' ||
          event.target.value.slice(-1) === 'K'
        ) {
          // get the value after slicing the last character
          const value1 = parseFloat(event.target.value.slice(0, -1));
          value = value1 * 1000;
        }
        // if user input 'B/b' keyword
        if (
          event.target.value.slice(-1) === 'b' ||
          event.target.value.slice(-1) === 'B'
        ) {
          // get the value after slicing the last character
          const value1 = parseFloat(event.target.value.slice(0, -1));
          value = value1 * 1000000000;
        }
        // if user input 'M/m' keyword
        if (
          event.target.value.slice(-1) === 'm' ||
          event.target.value.slice(-1) === 'M'
        ) {
          // get the value after slicing the last character
          const value1 = parseFloat(event.target.value.slice(0, -1));
          value = value1 * 1000000;
        }
        // if user input 'T/t' keyword
        if (
          event.target.value.slice(-1) === 't' ||
          event.target.value.slice(-1) === 'T'
        ) {
          // get the value after slicing the last character
          const value1 = parseFloat(event.target.value.slice(0, -1));
          value = value1 * 1000000000000;
        }
      }
    }
    if (this.settings.suffix === '%') {
      if (value.length === 1 && value === '.') {
        value = '';
        this.el.value = this.currencyPipe.transform(value, this.settings);
      }
    }

    // if value or value is 0, and value is not equal to k, m, b, t.
    if ((value || parseInt(value, 10) === 0) &&
      (value.toString().toLowerCase() !== 'k' && value.toString().toLowerCase() !== 'b' &&
        value.toString().toLowerCase() !== 'm' && value.toString().toLowerCase() !== 't')) {
      this.transformAndParseValue(value);
    } else {
      this.value = '';
    }

    if (this.settings.decimal_separator) {
      this.value = this.value && this.value.toString().replace(this.settings.decimal_separator, '.');
    }

    // check if only k, m, b, t is typed.
    if (this.el.value.toLowerCase() === 'k') {
      this.value = 1000;
      this.transformAndParseValue(this.value);
    } else if (this.el.value.toLowerCase() === 'b') {
      this.value = 1000000000;
      this.transformAndParseValue(this.value);
    } else if (this.el.value.toLowerCase() === 'm') {
      this.value = 1000000;
      this.transformAndParseValue(this.value);
    } else if (this.el.value.toLowerCase() === 't') {
      this.value = 1000000000000;
      this.transformAndParseValue(this.value);
    }

    if (
      this.model.hasOwnProperty('viewModel') &&
      this.previousValue !== this.value
    ) {
      this.model.update.emit(this.value);
    } else if (
      this.formControlName &&
      this.formControlName.valueChanges &&
      this.previousValue !== this.value
    ) {
      this.formControlName.control.setValue(this.value);
    }
  }

  /**
   * transform the value with prefix and parse as per the decimal places.
   * @param value
   */
  transformAndParseValue(value) {
    this.el.value = this.currencyPipe.transform(value, this.settings);
    if (this.settings.view_roundoff) {
      this.value = this.currencyPipe.parse(value, this.settings);
    } else {
      this.value = this.currencyPipe.parse(this.el.value, this.settings);
    }
  }
}
